import { Spinner } from 'components/UI/V3/Spinner/Spinner';
import { FunctionComponent } from 'react';
import { Moment } from 'moment-timezone';
import { formatPayoutAmount } from 'utils/PaymentsUtils';
import InfoTooltip from './InfoTooltip';
import styles from './ScheduledPayout.module.scss';

interface ScheduledPayoutProps {
    amount: number | string;
    date?: Moment | null;
    loading?: boolean;
}

export const ScheduledPayout: FunctionComponent<ScheduledPayoutProps> = ({ amount, date, loading }) => {
    return (
        <div className={styles.root}>
            <div className={styles.content}>
                <div className={styles.header}>
                    <p className={styles.title}>Scheduled Payout</p>
                    <InfoTooltip
                        content="Funds that have settled and are scheduled to be automatically sent to your bank account."
                        ariaLabel="Scheduled Payout information"
                    />
                </div>
                {loading ? (
                    <div className={styles.spinner}>
                        <Spinner size={32} />
                    </div>
                ) : (
                    <>
                        <span className={styles.amount}>{formatPayoutAmount(amount)}</span>
                        {date && (
                            <div className={styles.dateBadge}>
                                <span className={styles.date}>{date.format('MMM D, YYYY')}</span>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
};

export default ScheduledPayout;
